import Vue from 'vue'
import VueRouter from 'vue-router'
import library from '@/views/library.vue'
import login from '@/views/login.vue'
import booklist from '@/views/booklist.vue'
import bookInfo from '@/views/bookInfo.vue'
import book from '@/views/book.vue'
import { app } from '@/firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/index.html',
    name: 'indexhtml',
    component: library
  },
  {
    path: '/',
    name: 'Library',
    component: library,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/',
        name: 'booklist',
        component: booklist
      },
      {
        path: '/booklist',
        name: 'booklist',
        component: booklist
      },
      {
        path: '/bookinfo',
        name: 'bookinfo',
        component: bookInfo
      },
      {
        path: '/bookinfo/:id',
        name: 'bookinfo',
        component: bookInfo
      },
      {
        path: '/book/:book',
        name: 'book',
        component: book
      },
    ]
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from, next) =>{
  let currentUser = app.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login')
  else if (!requiresAuth && currentUser) next('/')
  else next()
})

export default router
